import { z } from "zod";

export const calendarFormSchema = z.object({
  configurationOptions: z.object({
    absencePlanningEnabled: z.boolean(),
  }),
  name: z
    .string()
    .min(1, "Nazwa kalendarza jest wymagana.")
    .max(100, "Nazwa kalendarza jest za długa, maksymalnie 100 znaków"),
  description: z.optional(
    z.string().max(255, "Opis kalendarza jest za długi, maksymalnie 255 znaków")
  ),
  year: z.string().length(4, "Wprowadzona forma roku jest niepoprawna."),
});
